import { SK_userSession } from '../../../../data/config';
import { parseJsonFromLocal } from '../../../../utils/helperFunction/jsonHandler';
import { UserSessionType } from '../userSession';

const getInitialUserSessionState = (): UserSessionType => {
  const stateInLocalStorage =
    parseJsonFromLocal<UserSessionType>(SK_userSession);
  const defaultValue = {
    signedAccessToken: undefined,
    signedRefreshPayload: undefined,
  };
  return stateInLocalStorage || defaultValue;
};

export default getInitialUserSessionState;
